import data from './data.json';

export const parseErrorFromBack = (errors) => {
  const errorsCompleted = {};
  Object.keys(errors).forEach((key) => {
    const parsedError = {};
    const currentValue = errors[key][0];
    if (currentValue.includes('||')) {
      const errorWithParams = currentValue.split('||')
      errorWithParams.forEach((error, index) => {
        const param = error.split(':')
        const name = param[0].trim();
        const value = param[1].trim();
        if (index === 0) parsedError['code'] = param[1].trim();
        else parsedError[name] = value;
        parsedError['field'] = key;
        parsedError[name] = value;
        errorsCompleted[key] = parsedError;
      });
    } else {
      const value = currentValue.replace(/ /g, '').split(':')
      parsedError['code'] = value[1];
      parsedError['field'] = key
      errorsCompleted[key] = parsedError;
    }
  })
  return errorsCompleted;
}

export const parseErrorMessage = (error) => {
  const { code, field, ...parameters  } = error;
  let errorMessage = data[code];
  const paramsNames = Object.keys(parameters);
  paramsNames.forEach((key) => errorMessage = errorMessage.replace(`{{${key}}}`, parameters[key]));
  return errorMessage;
};

export const parseFieldErrors = (errors) => {
  const errorMessages = [];
  Object.keys(errors).forEach((key) => {
    const currentValue = errors[key];
    const { code, field } = currentValue;
    const error = { code, field, message: parseErrorMessage(currentValue)};
    errorMessages.push(error);
  })
  return errorMessages;
};
